var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IntersectionType } from "@nestjs/swagger";
import { Type } from "class-transformer";
import { IsDate, IsNumber, IsOptional } from "class-validator";
export const allAccessTypes = ["AVAILABLE", "FULL_RECORD", "IDENTIFIED_RECORD"];
class PatientsStats {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], PatientsStats.prototype, "totalAvailablePatients", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], PatientsStats.prototype, "totalIdentifiedPatients", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], PatientsStats.prototype, "totalFullRecordsAccessedPatients", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], PatientsStats.prototype, "totalIdentifiedRecordsAccessedPatients", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], PatientsStats.prototype, "totalAnyRecordsAccessedPatients", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], PatientsStats.prototype, "totalPrescreenConsentedPatients", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], PatientsStats.prototype, "totalReadyToEnrollingPatients", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], PatientsStats.prototype, "totalEnrolledPatients", void 0);
class RecordAccessStats {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], RecordAccessStats.prototype, "totalFullRecordsAccessed", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], RecordAccessStats.prototype, "totalIdentifiedRecordsAccessed", void 0);
class StudyRecordAccessStats {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], StudyRecordAccessStats.prototype, "totalStudiesAccessingFullRecords", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], StudyRecordAccessStats.prototype, "totalStudiesAccessingIdentifiedRecords", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], StudyRecordAccessStats.prototype, "totalStudiesAccessingAnyRecords", void 0);
export class Stats extends IntersectionType(PatientsStats, RecordAccessStats, StudyRecordAccessStats) {
}
export class StudyStats extends IntersectionType(PatientsStats, RecordAccessStats) {
}
export class TimelineStats extends RecordAccessStats {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], TimelineStats.prototype, "totalAvailablePatients", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], TimelineStats.prototype, "endOfWeek", void 0);
export class PatientStats {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], PatientStats.prototype, "totalStudiesContributedTo", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], PatientStats.prototype, "totalResearchAreasContributedTo", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], PatientStats.prototype, "totalRequestsReceived", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], PatientStats.prototype, "healthSystemTotalPatients", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], PatientStats.prototype, "healthSystemTotalStudiesContributedTo", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], PatientStats.prototype, "healthSystemResearchAreasContributedTo", void 0);
export var StatsInterval;
(function (StatsInterval) {
    StatsInterval["DAILY"] = "DAILY";
    StatsInterval["WEEKLY"] = "WEEKLY";
})(StatsInterval || (StatsInterval = {}));
export class HealthSystemStats {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], HealthSystemStats.prototype, "totalAvailablePatients", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], HealthSystemStats.prototype, "totalPatientsCompletedOnboarding", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], HealthSystemStats.prototype, "totalPatientsOptedOutOfHealthEx", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], HealthSystemStats.prototype, "totalEnrollmentConsentedPatients", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], HealthSystemStats.prototype, "totalPrescreenConsentedPatients", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], HealthSystemStats.prototype, "totalRequestedEnrollmentConsentedPatients", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], HealthSystemStats.prototype, "totalRequestedPrescreenConsentedPatients", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], HealthSystemStats.prototype, "totalIdentifiedPatients", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], HealthSystemStats.prototype, "totalIdentifiedRecordsAccessed", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], HealthSystemStats.prototype, "totalResearchStudies", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], HealthSystemStats.prototype, "totalConditionsAndDiseases", void 0);
export class HealthSystemStatsDto extends HealthSystemStats {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], HealthSystemStatsDto.prototype, "date", void 0);
